import { render, staticRenderFns } from "./SchoolLeaveDetailCreateForm.vue?vue&type=template&id=06d96266&scoped=true&"
import script from "./SchoolLeaveDetailCreateForm.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveDetailCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d96266",
  null
  
)

export default component.exports